import { IEventLoggingComponentProps, withEventLogging } from '@AppModels/Logging';
import { Industry } from '@ViewModels';
import { css, StyleDeclarationValue } from 'aphrodite';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import { RouteComponentProps, Switch } from 'react-router-dom';
import { AdminDefaultSupportedIndustries } from '../../../../models';
import { IAdminUserSessionComponentProps } from '../../../../models/AdminModels';
import { UserSessionViewModelKey } from '../../../../models/AppState';
import { getIndustryName } from '../../../../models/UiUtils';
import { AdminPrivateRoute } from '../../../components/AdminPrivateRoute';
import { IndustryTemplatesCard } from '../../../components/campaigns/IndustryTemplatesCard';
import { AdminNotFoundContainer } from '../../AdminNotFoundContainer';
import { IndustryTemplatesActionBarHeader } from './prensentation';
import { styleSheet } from './styles';

interface IProps extends IEventLoggingComponentProps, RouteComponentProps<any>, IAdminUserSessionComponentProps {
	className?: string;
	industries?: Industry[];
	onRenderTemplatesByIndustryRoute(industry: Industry, props: RouteComponentProps<any>): React.ReactNode;
	styles?: StyleDeclarationValue[];
	children?: React.ReactNode;
}

interface IIndustryTemplates {
	ActionBarHeader: React.FC<React.PropsWithChildren>;
}

class _IndustryTemplates extends React.Component<IProps> {
	public render() {
		const { className, styles, industries, match, children, location } = this.props;
		const isAutomations = location.pathname.includes('automations');
		return (
			<div className={`${css(...(styles || []))} industry-templates ${className || ''}`}>
				<Switch>
					{(industries || AdminDefaultSupportedIndustries).map(x => {
						return (
							<AdminPrivateRoute
								key={`${x}`}
								pageViewLogName={`${x.split(' ').join()}CampaignTemplates`}
								path={`${match.path}/${getIndustryName(x)}`}
							>
								{this.onRenderTemplatesByIndustryRoute(x)}
							</AdminPrivateRoute>
						);
					})}
					<AdminPrivateRoute path={match.path} exact={true}>
						<>
							{children}
							<div className={css(styleSheet.section, !isAutomations && styleSheet.sectionBumper)}>
								<div className={css(styleSheet.sectionTitle)}>Manage Per Vertical</div>
								<div className={css(styleSheet.cards)}>
									<div className={css(styleSheet.cardsContent)}>
										{AdminDefaultSupportedIndustries.map((industry, i) => {
											return (
												<IndustryTemplatesCard
													industry={industry}
													key={`${industry}-${i}`}
													onClick={this.onIndustryCardClicked(industry)}
													styles={[styleSheet.card]}
												/>
											);
										})}
									</div>
								</div>
							</div>
						</>
					</AdminPrivateRoute>
					<AdminPrivateRoute>
						<AdminNotFoundContainer />
					</AdminPrivateRoute>
				</Switch>
			</div>
		);
	}

	private onRenderTemplatesByIndustryRoute = (industry: Industry) => (props: RouteComponentProps<any>) => {
		return this.props.onRenderTemplatesByIndustryRoute(industry, props);
	};

	private onIndustryCardClicked = (industry: Industry) => () => {
		const { history, match } = this.props;
		history?.push(`${match.path}/${getIndustryName(industry)}`);
	};
}

const IndustryTemplatesAsObserver = observer(_IndustryTemplates);
const IndustryTemplatesWithContext = inject(UserSessionViewModelKey)(IndustryTemplatesAsObserver);
const IndustryTemplatesWithLogging = withEventLogging(IndustryTemplatesWithContext, 'IndustryTemplates');
export const IndustryTemplates: Partial<IIndustryTemplates> &
	React.ComponentClass<Omit<IProps, keyof RouteComponentProps<any>>> = withRouter(IndustryTemplatesWithLogging);

IndustryTemplates.ActionBarHeader = IndustryTemplatesActionBarHeader;
